import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';

import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c(VDialog, {
    style: {
      zIndex: _vm.options.zIndex
    },
    attrs: {
      persistent: "",
      width: "1000",
      "max-width": "100%"
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.cancel.apply(null, arguments);
      }
    },
    model: {
      value: _vm.shown,
      callback: function callback($$v) {
        _vm.shown = $$v;
      },
      expression: "shown"
    }
  }, [_c(VCard, [_c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle",
    on: {
      click: function click($event) {
        return _vm.cancel();
      }
    }
  })], 1), _c(VCardTitle, [_c("span", {
    staticClass: "text-h5"
  }, [_vm._v("Cogs history")])]), _c(VCardText, [_c(VDataTable, {
    staticClass: "elevation-2 --background-transparent --no-shadow --border-1",
    attrs: {
      id: "table",
      headers: _vm.headers,
      items: _vm.values,
      "hide-default-footer": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "item.date",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(_vm._f("formatDateTimeToLocal")(item.date)) + " ")];
      }
    }, {
      key: "item.cogs",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [item.previousCogs ? _c("span", {
          staticClass: "mr-1"
        }, [_vm._v(" " + _vm._s(_vm.formatPrice(item.previousCogs)) + " € "), _c(VIcon, {
          staticClass: "fa fa-arrow-right",
          attrs: {
            size: "0.65rem"
          }
        })], 1) : _vm._e(), _c("span", [_vm._v(_vm._s(_vm.formatPrice(item.newCogs)) + " €")])];
      }
    }, {
      key: "item.comment",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c("div", {
          domProps: {
            innerHTML: _vm._s(String.nl2br(item.comment))
          }
        })];
      }
    }, {
      key: "item.user",
      fn: function fn(_ref4) {
        var _item$user$fullname, _item$user;
        var item = _ref4.item;
        return [_vm._v(" " + _vm._s((_item$user$fullname = (_item$user = item.user) === null || _item$user === void 0 ? void 0 : _item$user.fullname) !== null && _item$user$fullname !== void 0 ? _item$user$fullname : "-") + " ")];
      }
    }], null, true)
  })], 1), _c(VCardActions, {
    staticClass: "actions-bottom-container"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.cancel();
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };